import { RouteFactory } from "@app/routePaths";
import SCLogo from "@assets/verticals/standard-chartered-logo.svg";
import SectionMasthead from "@components/SectionMasthead/SectionMasthead";
import { VERTICAL_MASTHEADS } from "@routes/Section/layouts/Verticals/utils/constant";
import { cn } from "@util/helpers";

type GlobalEnterpriseBannerProps = {
  /** Optional additional styling to the component */
  className?: string;
};

/**
 * Banner component for the Global Enterprise vertical, featuring the masthead and sponsor logo.
 */
const GlobalEnterpriseBanner = ({
  className,
}: GlobalEnterpriseBannerProps): React.ReactElement => {
  return (
    <div
      className={cn(
        "mx-auto flex w-full flex-wrap items-center justify-center gap-4 border-b border-gray-175 pb-4 lg:justify-between",
        className
      )}
    >
      <SectionMasthead
        link={RouteFactory.globalEnterprise}
        masthead={VERTICAL_MASTHEADS.global}
        className="w-[11.5rem] lg:w-[13.5rem]"
      />

      <div className="block h-[1px] w-full bg-gray-175 lg:hidden "></div>

      <div className="flex items-center justify-end gap-x-4">
        <span className="font-poppins text-4xs font-normal leading-normal tracking-5% md:text-xs">
          BROUGHT TO YOU BY
        </span>

        <img src={SCLogo} alt="UOB logo" className="w-[5rem]" width="90" />
      </div>
    </div>
  );
};

export default GlobalEnterpriseBanner;
